import axios, { AxiosInstance } from 'axios'
import axiosRetry from 'axios-retry'

const axiosInstance: AxiosInstance = axios.create({
  baseURL: import.meta.env.VITE_PAYTRIE_API_URL,
})
axiosRetry(axiosInstance)

export default axiosInstance
